module.exports = __webpack_public_path__ + "static/media/007_Azure_marketplace_page_withdtr.9de37b00.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/007_Azure_marketplace_page_withdtr.png
// module id = 386
// module chunks = 0